<app-loading-overlay
  *ngIf="(route$ | async) === '/login'"
></app-loading-overlay>
<router-outlet></router-outlet>
